export default "__VITE_ASSET__da2d6394__"